module.exports = __webpack_public_path__ + "img/3d-mobile_en.f5a86d2.jpg";